import { appSelectors } from '@appStore/reducers/app'
import { workspaceApi } from 'features/workspace'
import { useAppSelector } from 'shared/hooks'

function hasLinkedProfile(linkedProfile: unknown) {
	const result =
		linkedProfile !== null &&
		typeof linkedProfile === 'object' &&
		Object.keys(linkedProfile as object).length > 0
	return result
}

function useAutomationLinkedInStatus() {
	const linkedProfile = useAppSelector(appSelectors.linkedProfile)
	const linkedProfileExist = hasLinkedProfile(linkedProfile)
	const query = workspaceApi.useAutomationModeQuery(undefined, {
		skip: !linkedProfileExist
	})

	const isSignedIn =
		query.isSuccess && query.data.is_signed_in_at_linkedIn === true
	const isSignedOut =
		query.isSuccess && query.data.is_signed_in_at_linkedIn === false

	const result = {
		autoMode: query.data,
		isFetching: query.isFetching,
		isSignedIn,
		isSignedOut,
		isSuccess: query.isSuccess,
		linkedProfileExist
	}
	return result
}

export { hasLinkedProfile, useAutomationLinkedInStatus }
